import { render, staticRenderFns } from "./password-input.vue?vue&type=template&id=bca266c4&scoped=true&"
import script from "./password-input.vue?vue&type=script&lang=js&"
export * from "./password-input.vue?vue&type=script&lang=js&"
import style0 from "./password-input.vue?vue&type=style&index=0&id=bca266c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca266c4",
  null
  
)

export default component.exports